<template>
  <Autocompleter
    :value="{ id: value.id, name: !nameEmptyAllow && $options.utils.emptyOrWhitespaced( value.name ) ? value.id : value.name  }"
    :getItemsParams="itemsParams()"
    :getItems="itemsGet"
    :disabled="disabled"
    class="control"
    @input="set"
    @ok="$emit( 'ok', $event )"
  />
</template>

<script>

import utils from "@/utils";
import Autocompleter from "./Autocompleter";

export default {
	name:  "DVfieldReference",

  components: {
    Autocompleter
  },

	props: {
		label:    {
			type:    String,
			default: "",
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
    refs: {
		  type: Array,
      default: () => []
    },
		value:  {
			type:    Object,
      validator( v ) {
			  return v && ( "id" in v ) && ( "name" in v );
      },
		},
    misc: {
		  type:  Object,
      default: () => null
    },
    nameEmptyAllow: {
		  type: Boolean,
      default: false
    }
	},

  utils,

	data() {
		return {
		};
	},

	mounted() {
	},

	methods: {
	  itemsParams() {
      return {
        refs: this.refs.map( i => typeof( i ) === 'object' ? i.id : i ),
        ...( this.misc && this.misc.params && this.misc.params )
      }
    },
		async itemsGet( query, params ) {
		  if ( this.misc && this.misc.itemsGet ) return this.misc.itemsGet( query, params, this.misc );

		  try {
        const ans = await this.$options.api.post.json(
          this.misc && this.misc.URL ? this.misc.URL : "/ac",
          {
            ...this.queryStd,

            ...params,
            query
          }
        );

        if ( !ans ) throw new Error( this.$t( "InvalidServerAnswer" ) );
        if ( ans.error ) throw new Error( ans.error );
        if ( Array.isArray( ans.errors ) && ans.errors.length ) throw new Error( ans.errors.join( "; " ) );
        if ( !( "items" in ans ) ) throw new Error( this.$t( "InvalidServerAnswer" ) + ": " + JSON.encode( ans ) );

        if ( !this.nameEmptyAllow ) {
          for ( const item of ans.items ) {
            if ( utils.emptyOrWhitespaced( item.name ) ) item.name = item.id;
          }
        }

        return ans.items;
      }
      catch ( e ) {
		    console.error( "DVFIELDREFERENCE REQUEST ERROR: request items is failed with " + e.message, e.stack );

        this.$root.$emit( "notify", { header: this.$t( "Error" ), message: e.message, type: "error" } );
      }

      return [];
		},

		set( event ) {
			this.$emit( "input", { id: event.id, name: event.name } );
		}
	}
};
</script>

<style scoped>
.control::v-deep *[data-focus] {
  border-radius: 0.2em;
  border: 0;
  padding: .2em 1em .2em .5em;
  box-shadow: inset 1px 1px 1px rgba( 0, 0, 0, 0.5 );
}

.control::v-deep .results {
  border-radius: 0.2em;
  border: 0;
  box-shadow: 0 0 0 0.09em rgba( 0, 0, 0, .25 ), 0 0.2em 0.2em 0 rgba( 0, 0, 0, .35 );
	transform: translate( 0, 99% );
}
</style>